import { StyledEngineProvider } from "@mui/material";
import { StylesProvider } from "@mui/styles";
import ThemeProvider from "@mui/styles/ThemeProvider";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import smoothscroll from "smoothscroll-polyfill";
import App from "./App";
import "./index.css";
import ErrorBoundary from "./utils/ErrorBoundary";
import { store } from "./utils/store";
import { theme } from "./utils/styles";

// steps to override default smooth scrolling behaviour in browsers
declare global {
  interface Window {
    __forceSmoothScrollPolyfill__: boolean;
  }
}
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <StylesProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <React.StrictMode>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </React.StrictMode>
        </Provider>
      </ThemeProvider>
    </StylesProvider>
  </StyledEngineProvider>,
  document.getElementById("root")
);

// serviceWorker.unregister();
